<template>
	<div>
		<div class="row">
			<div class="col s12 m8 l10 xl10">
				<div class="row">
					<div class="input-field col s12">
						<i class="material-icons prefix ">search</i>
						<input id="search" type="text" class="validate" v-model="filterTerm">
						<label for="search">Pesquisar</label>
					</div>
				</div>
			</div>
		</div>

		<div class="row">
			<div class="col s12 m12 l12 xl12">
				<table>
					<thead>
						<tr>
							<th class="hide-on-med-and-down">
								#
								<a class="left" href="#" @click="toggleOrder($event, 'id')">
									<i class="material-icons" v-bind:class="{ 'red-text': sortPropertyId }" >sort</i>
								</a>
							</th>
							<th>
								Ação
								<a class="left" href="#" @click="toggleOrder($event, 'projeto.titulo')">
									<i class="material-icons" v-bind:class="{ 'red-text': sortPropertyProjeto }" >sort</i>
								</a>
							</th>
							<th class="hide-on-med-and-down">
								Bolsista
								<a class="left" href="#" @click="toggleOrder($event, 'aluno.name')">
									<i class="material-icons" v-bind:class="{ 'red-text': sortPropertyBolsista }" >sort</i>
								</a>
							</th>
							<th>
								Período
							</th>
							<th>
								Operação
							</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(bolsa, index) in filteredBolsas">
							<td class="hide-on-med-and-down">{{ index + 1 }}</td>
							<td>
								<a :href="'/projetos/'+bolsa.projeto.id+'/edit/editable/false'">{{ bolsa.projeto.titulo }}</a>
							</td>            
							<td class="hide-on-med-and-down">
								<a v-if="bolsa.aluno" :href="'/usuario/' + bolsa.aluno.id">{{ bolsa.aluno.name }}</a>
							</td>
							<td v-if="bolsa.aluno">{{ formatarData(bolsa.entrada) }}-<br>{{ bolsa.saida? formatarData(bolsa.saida) : '' }}</td>
							<td v-else></td>
							<td>
								<a v-if='!bolsa.aluno' :href="'/bolsas/atribuicao/' + bolsa.id" class="cyan waves-effect waves-light btn-small left" title="Atribuir bolsa a aluno">
									<i class="material-icons">add</i>
								</a>
								<a v-if='!bolsa.saida && bolsa.aluno' :href="'/bolsas/remocao/' + bolsa.id" class="red waves-effect waves-light btn-small left" title="Remover bolsa de aluno">
									<i class="material-icons">remove</i>
								</a>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
    export default {
		name: "VueBolsasAtribuicaoList",
		props: [
			'bolsas'
		],
		data () {
			return {
				listaBolsas: JSON.parse(this.bolsas),
				sortProperty: 'id',
				sortDirection: 'asc',
				filterTerm: '',
				sortPropertyId: true,
				sortPropertyProjeto: false,
				sortPropertyBolsista: false,
			}
		},
		computed: {
			listOp: function () {
				this.listaBolsas = _.orderBy(this.listaBolsas, this.sortProperty, this.sortDirection)
			},
        filteredBolsas: function () {
          var self = this
          return _.orderBy(self.listaBolsas.filter(function (relatorio) {
            var searchRegex = new RegExp(self.filterTerm, 'i')
            return (
              searchRegex.test(relatorio.id) ||
              searchRegex.test(relatorio.projeto.titulo) ||
              searchRegex.test(relatorio.aluno.name)
            )
          }), this.sortProperty, this.sortDirection)
        },
      },
      methods: {
        toggleOrder (ev, field) {
          ev.preventDefault()
          if (this.sortProperty == field){
            if (this.sortDirection == 'asc')
              this.sortDirection = 'desc'
            else
              this.sortDirection = 'asc'
          } else {
            this.iconsColor(this.sortProperty, false)
            this.iconsColor(field, true)
            this.sortProperty = field
            this.sortDirection = 'asc'
          }
        },
        iconsColor(field, value){
          switch (field) {
            case 'id':
              this.sortPropertyId = value
              break;
            case 'projeto.titulo':
              this.sortPropertyProjeto = value
              break;
            case 'aluno.name':
              this.sortPropertyBolsista = value
              break;
            default:
          }
        },
		formatarData(data) {
			var objeto = new Date(data);
			return objeto.getDate() + '/' + (objeto.getMonth() + 1) + '/' + objeto.getFullYear(); 
		},
	  },
    }
</script>
